import React from 'react';
import styles from './QuantityDropdown.module.scss';

interface Props {
  setQuantity: (quantity: number) => void;
  maxQuantity?: number;
  style?: React.CSSProperties;
}

export const QuantityDropdown: React.FC<Props> = ({ setQuantity, style, maxQuantity = 8 }) => {
  return (
    <select className={styles.dropdown} style={style} onChange={(e) => setQuantity(+e.target.value)}>
      {Array.from({ length: maxQuantity }).map((_, i) => (
        <option key={i} value={i + 1} label={`${i + 1}`}>
          {i + 1}
        </option>
      ))}
    </select>
  );
};

export default QuantityDropdown;
